module.exports = {"370881001":"鲁城街道","370881002":"书院街道","370881003":"时庄街道","370881004":"小雪街道","370881101":"吴村镇","370881102":"姚村镇","370881103":"陵城镇","370881105":"尼山镇","370881108":"王庄镇","370881109":"息陬镇","370881110":"石门山镇","370881111":"防山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370881.json
// module id = 1553
// module chunks = 0